import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { KebabCase } from 'type-fest'

import { NotPurchasedSection } from 'components/Section/NotPurchasedSection'
import { Tab } from 'components/Tabs'
import { Workspace } from 'features/workspace'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { GeneralTab } from './General/GeneralTab'
import { PrebidStackTab } from './PrebidStack/PrebidStackTab'
import { RichPlacements } from './RichPlacements/RichPlacements'

export type DefaultsTab = KebabCase<'general' | 'prebid-stack' | 'rich-placements'>

export type DefaultsUrlParams = Partial<{
  tab: DefaultsTab
  workspaceId: Workspace['id']
}>

export const useTabs = (): Tab<DefaultsTab>[] => {
  const { t } = useTranslation('features/globalSetup')
  const { t: tProduct } = useTranslation('features/product')

  const ability = useAbility()

  const noAccessToGeneral: boolean = ability.cannot('access', 'GlobalSetupPage-defaults-general')

  const noAccessToPrebid: boolean =
    ability.cannot('access', 'Product-prebidStack') ||
    ability.cannot('access', 'GlobalSetupPage-defaults-prebidStack')

  const noAccessToRichPlacements: boolean =
    ability.cannot('access', 'Product-richPlacements') ||
    ability.cannot('access', 'GlobalSetupPage-defaults-richPlacements')

  return [
    {
      disabled: noAccessToGeneral,
      element: 'general',
      label: t('defaults.general.tab'),
      page: noAccessToGeneral ? <Navigate to={ROUTES.BASE.NOT_FOUND} /> : <GeneralTab />,
    },
    {
      disabled: noAccessToPrebid,
      element: 'prebid-stack',
      label: tProduct('product.prebidStack'),
      page: noAccessToPrebid ? <NotPurchasedSection /> : <PrebidStackTab />,
    },
    {
      disabled: noAccessToRichPlacements,
      element: 'rich-placements',
      label: tProduct('product.richPlacements'),
      page: noAccessToRichPlacements ? <NotPurchasedSection /> : <RichPlacements />,
      section: 'multi-anchor',
    },
  ]
}
